export const EMAIL_VALIDATION = 'EMAIL_VALIDATION';
